export class LoggedIn {
  id: number;
  username: string;
  label: string;
  email: string;
  lang: string;
  supervisor: boolean;

  constructor(
    id: number,
    username: string,
    label: string,
    email: string,
    supervisor: boolean,
    lang: string
  ) {
    this.id = id;
    this.username = username;
    this.label = label;
    this.email = email;
    this.supervisor = supervisor;
    this.lang = lang;
  }
}
